// This function calculates the total percentage change in value based on the asset heldvalue, change percentage and current price.
const calculateHeldValue = function(assets, field) {
    let total = 0;
    let previousPeriodValue = 0;
    for(const asset of (assets)) {
        const {price, heldAmount = 0} = asset;
        total += (price * heldAmount);
        previousPeriodValue += (price / (100 + asset[field]) * 100) * asset.heldAmount;
    }
    return previousPeriodValue > 0 ? ((total / previousPeriodValue - 1) * 100) : 0;
};
  
  
  export { calculateHeldValue };
  
  